module.exports = __webpack_public_path__ + "img/section5_m.90712d4b.png";